// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home {
  padding: 0;
}

.home-banner {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-primary-700) 60%, #0b3d1f 100%);
  color: #fff;
  overflow: hidden;
}

.home-banner::after {
  content: '';
  position: absolute;
  inset: 0;
  background-image: radial-gradient(rgba(255,255,255,0.08) 1px, transparent 1px);
  background-size: 24px 24px;
  pointer-events: none;
}

.home-hero {
  position: relative;
  text-align: center;
  padding: 24px;
}

.home-title {
  font-size: clamp(28px, 5vw, 48px);
  line-height: 1.1;
  margin: 0 0 12px;
}

.home-subtitle {
  font-size: clamp(14px, 2.4vw, 18px);
  opacity: 0.9;
  margin: 0 0 24px;
}

.home-cta {
  display: inline-block;
  padding: 12px 20px;
  border-radius: 999px;
  background: #ecfdf5;
  color: var(--color-primary-700);
  text-decoration: none;
  font-weight: 600;
  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.2s ease;
  box-shadow: 0 8px 24px rgba(22, 163, 74, 0.28);
}

.home-cta:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 28px rgba(22, 163, 74, 0.38);
  background: #d1fae5;
}

.home-content {
  padding: 24px 16px 40px;
  max-width: 920px;
  margin: 0 auto;
}

.home-section-title {
  margin: 0 0 8px;
}

.home-section-text {
  margin: 0;
  color: #334155;
}

.home-footer {
  margin-top: 24px;
  padding: 20px 16px;
  background: #f8fafc;
  border-top: 1px solid var(--color-border);
  color: #334155;
  text-align: center;
}

.home-footer p {
  margin: 6px 0;
}

.info-card {
  /* Frosted glass effect */
  background: linear-gradient(135deg, rgba(255, 245, 247, 0.55), rgba(255, 255, 255, 0.35));
  backdrop-filter: blur(12px) saturate(120%);
  -webkit-backdrop-filter: blur(12px) saturate(120%);
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 16px;
  padding: 24px 20px;
  margin-top: 24px;
  box-shadow: 0 10px 30px rgba(2, 12, 6, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.4);
  text-align: center;
  background-clip: padding-box;
}

.info-card p {
  line-height: 1.6;
  margin: 10px 0;
}

.info-card a {
  color: var(--color-primary-700);
}

.info-card strong {
  color: #0b1f14;
}

/* Hide the extra home-page search by default (desktop/tablet) */
.home-search {
  display: none;
}

/* Mobile tweaks for 412x915 and below */
@media (max-width: 430px) {
  .site-header .brand {
    margin: 0 auto; /* center brand text in navbar */
  }
  .home-hero img {
    width: 120px !important;
    height: 120px !important;
  }
  .home-title {
    font-size: 28px;
  }
  .home-subtitle {
    font-size: 14px;
  }
  .home-search {
    margin-top: 12px;
    display: flex; /* visible only on mobile */
    justify-content: center;
  }
  .home-search .search-box {
    width: 92%;
    max-width: 360px;
    height: 38px;
  }
  .home-search .search-box input {
    height: 34px;
  }
  html, body {
    overflow-x: hidden; /* remove extra horizontal scroll */
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/Home.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,wGAAwG;EACxG,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,8EAA8E;EAC9E,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,+BAA+B;EAC/B,qBAAqB;EACrB,gBAAgB;EAChB,6EAA6E;EAC7E,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yCAAyC;EACzC,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,yFAAyF;EACzF,0CAA0C;EAC1C,kDAAkD;EAClD,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,oFAAoF;EACpF,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA,gEAAgE;AAChE;EACE,aAAa;AACf;;AAEA,wCAAwC;AACxC;EACE;IACE,cAAc,EAAE,gCAAgC;EAClD;EACA;IACE,uBAAuB;IACvB,wBAAwB;EAC1B;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,aAAa,EAAE,2BAA2B;IAC1C,uBAAuB;EACzB;EACA;IACE,UAAU;IACV,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB,EAAE,mCAAmC;EACzD;AACF","sourcesContent":[".home {\n  padding: 0;\n}\n\n.home-banner {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 60vh;\n  background: linear-gradient(135deg, var(--color-primary) 0%, var(--color-primary-700) 60%, #0b3d1f 100%);\n  color: #fff;\n  overflow: hidden;\n}\n\n.home-banner::after {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background-image: radial-gradient(rgba(255,255,255,0.08) 1px, transparent 1px);\n  background-size: 24px 24px;\n  pointer-events: none;\n}\n\n.home-hero {\n  position: relative;\n  text-align: center;\n  padding: 24px;\n}\n\n.home-title {\n  font-size: clamp(28px, 5vw, 48px);\n  line-height: 1.1;\n  margin: 0 0 12px;\n}\n\n.home-subtitle {\n  font-size: clamp(14px, 2.4vw, 18px);\n  opacity: 0.9;\n  margin: 0 0 24px;\n}\n\n.home-cta {\n  display: inline-block;\n  padding: 12px 20px;\n  border-radius: 999px;\n  background: #ecfdf5;\n  color: var(--color-primary-700);\n  text-decoration: none;\n  font-weight: 600;\n  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.2s ease;\n  box-shadow: 0 8px 24px rgba(22, 163, 74, 0.28);\n}\n\n.home-cta:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 12px 28px rgba(22, 163, 74, 0.38);\n  background: #d1fae5;\n}\n\n.home-content {\n  padding: 24px 16px 40px;\n  max-width: 920px;\n  margin: 0 auto;\n}\n\n.home-section-title {\n  margin: 0 0 8px;\n}\n\n.home-section-text {\n  margin: 0;\n  color: #334155;\n}\n\n.home-footer {\n  margin-top: 24px;\n  padding: 20px 16px;\n  background: #f8fafc;\n  border-top: 1px solid var(--color-border);\n  color: #334155;\n  text-align: center;\n}\n\n.home-footer p {\n  margin: 6px 0;\n}\n\n.info-card {\n  /* Frosted glass effect */\n  background: linear-gradient(135deg, rgba(255, 245, 247, 0.55), rgba(255, 255, 255, 0.35));\n  backdrop-filter: blur(12px) saturate(120%);\n  -webkit-backdrop-filter: blur(12px) saturate(120%);\n  border: 1px solid rgba(255, 255, 255, 0.6);\n  border-radius: 16px;\n  padding: 24px 20px;\n  margin-top: 24px;\n  box-shadow: 0 10px 30px rgba(2, 12, 6, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.4);\n  text-align: center;\n  background-clip: padding-box;\n}\n\n.info-card p {\n  line-height: 1.6;\n  margin: 10px 0;\n}\n\n.info-card a {\n  color: var(--color-primary-700);\n}\n\n.info-card strong {\n  color: #0b1f14;\n}\n\n/* Hide the extra home-page search by default (desktop/tablet) */\n.home-search {\n  display: none;\n}\n\n/* Mobile tweaks for 412x915 and below */\n@media (max-width: 430px) {\n  .site-header .brand {\n    margin: 0 auto; /* center brand text in navbar */\n  }\n  .home-hero img {\n    width: 120px !important;\n    height: 120px !important;\n  }\n  .home-title {\n    font-size: 28px;\n  }\n  .home-subtitle {\n    font-size: 14px;\n  }\n  .home-search {\n    margin-top: 12px;\n    display: flex; /* visible only on mobile */\n    justify-content: center;\n  }\n  .home-search .search-box {\n    width: 92%;\n    max-width: 360px;\n    height: 38px;\n  }\n  .home-search .search-box input {\n    height: 34px;\n  }\n  html, body {\n    overflow-x: hidden; /* remove extra horizontal scroll */\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
